import React from "react";
import StoriesListingPage from "~/src/components/story/pages/StoriesListingPage";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import BackToTop from "~/components/qol/BackToTop";

export default function Stories() {
  return (
    <NavbarLayout>
      <StoriesListingPage />
      <BackToTop />
    </NavbarLayout>
  );
}
